// extracted by mini-css-extract-plugin
module.exports = {"root":"LocaleSelect_root__1UbKs","select":"LocaleSelect_select__1uGTa"};